import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import { createScanModulesStore, ScanModulesState, ScanModulesStoreApi } from '../stores/createScanModulesStore';

const ScanModuleContext = createContext<ScanModulesStoreApi | null>(null);

export function useScanModuleStore<U>(selector: (s: ScanModulesState) => U): U {
  const api = useContext(ScanModuleContext);
  if (!api) {
    throw new Error('useScanModuleStore must be used within ScanModuleProvider');
  }
  return useStore(api, selector);
}

const ScanModuleProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [store] = useState(() => createScanModulesStore());

  // const { data: moduleSerials } = useFetchModuleSerials();

  // React.useEffect(() => {
  //   if (!moduleSerials) return;

  //   store.getState().init(moduleSerials);

  //   return () => {
  //     store.getState().clear();
  //   };
  // }, [moduleSerials]);

  return <ScanModuleContext.Provider value={store}>{children}</ScanModuleContext.Provider>;
};

export default ScanModuleProvider;
